import {
	REDACTION_RULES,
	SENSITIVE_CONTEXT_KEY_PATTERN
} from 'src/common/services/ObservabilityRedactionHelper.constants';

export const redactText = (text: string): string =>
	REDACTION_RULES.reduce(
		(acc, { pattern, replacement }) => acc.replace(pattern, replacement),
		text
	);

const redactContextValue = (key: string, value: unknown): unknown => {
	if (typeof value === 'string') {
		return SENSITIVE_CONTEXT_KEY_PATTERN.test(key) ? '<redacted>' : redactText(value);
	}

	if (Array.isArray(value)) {
		return value.map((item) => redactContextValue(key, item));
	}

	if (value && typeof value === 'object') {
		return redactContext(value as Record<string, unknown>);
	}

	return value;
};

export const redactContext = (
	context?: Record<string, unknown>
): Record<string, unknown> | undefined => {
	if (!context) {
		return undefined;
	}

	return Object.entries(context).reduce<Record<string, unknown>>((acc, [key, value]) => {
		acc[key] = redactContextValue(key, value);
		return acc;
	}, {});
};
